import React from 'react';
import './App.css';
import { Paper, Box, Tab, Container } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useNavigate, useLocation } from 'react-router-dom';

import Benoit from "./pages/Benoit";
import Astro from "./pages/Astro";
import Contact from "./pages/Contact";
import Soft from "./pages/Soft";
import Publis from "./pages/Publis";
import Teaching from "./pages/Teaching";
import Welcome from "./pages/Welcome";

const bannerImages = [
    `${process.env.PUBLIC_URL}/images/banner/header0.png`,
    `${process.env.PUBLIC_URL}/images/banner/header1.png`,
    `${process.env.PUBLIC_URL}/images/banner/header2.png`,
    `${process.env.PUBLIC_URL}/images/banner/header3.png`,
    `${process.env.PUBLIC_URL}/images/banner/header4.png`,
    `${process.env.PUBLIC_URL}/images/banner/header5.png`,
    `${process.env.PUBLIC_URL}/images/banner/header6.png`,
    `${process.env.PUBLIC_URL}/images/banner/header7.png`,
    `${process.env.PUBLIC_URL}/images/banner/header8.png`,
];

// Correspondance chemin URL ↔ valeur d'onglet
const TABS = [
    { value: '1', path: '/',              label: 'Welcome'       },
    { value: '2', path: '/curriculum',    label: 'Curriculum'    },
    { value: '3', path: '/publications',  label: 'Publications'  },
    { value: '4', path: '/contributions', label: 'Contributions' },
    { value: '5', path: '/teaching',      label: 'Teaching'      },
    { value: '6', path: '/astro',         label: 'Astro'         },
    { value: '7', path: '/contact',       label: 'Contact'       },
];

function App() {
    const navigate  = useNavigate();
    const location  = useLocation();

    const [bannerImage] = React.useState(() => {
        const randomIndex = Math.floor(Math.random() * bannerImages.length);
        return bannerImages[randomIndex];
    });

    // Détermine l'onglet actif depuis l'URL courante
    const currentTab = TABS.find(t => t.path === location.pathname)?.value ?? '1';

    const handleChange = (event, newValue) => {
        const tab = TABS.find(t => t.value === newValue);
        if (tab) navigate(tab.path);
    };

    return (
        <Box sx={{
            bgcolor: '#f5f7fa',
            minHeight: '100vh',
            py: 5
        }}>
            <Container maxWidth="lg">
                <Paper
                    elevation={3}
                    sx={{
                        borderRadius: 4,
                        overflow: 'hidden',
                    }}
                >
                    {/* Bannière */}
                    <Box sx={{
                        height: 200,
                        position: 'relative',
                        backgroundImage: `url(${bannerImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: '40%',
                            background: 'linear-gradient(transparent, rgba(255,255,255,0.8))'
                        }
                    }} />

                    <TabContext value={currentTab}>
                        <Box sx={{
                            borderBottom: 1,
                            borderColor: 'divider',
                            display: 'flex',
                            justifyContent: 'center',
                            bgcolor: 'background.paper'
                        }}>
                            <TabList
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                textColor="primary"
                                indicatorColor="primary"
                                sx={{
                                    '& .MuiTab-root': {
                                        fontWeight: 600,
                                        fontSize: '0.85rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        px: 3,
                                        py: 2
                                    }
                                }}
                            >
                                {TABS.map(t => (
                                    <Tab key={t.value} label={t.label} value={t.value} />
                                ))}
                            </TabList>
                        </Box>

                        <Box sx={{ p: { xs: 2, md: 4 } }}>
                            <TabPanel value="1"><Welcome /></TabPanel>
                            <TabPanel value="2"><Benoit /></TabPanel>
                            <TabPanel value="3"><Publis /></TabPanel>
                            <TabPanel value="4"><Soft /></TabPanel>
                            <TabPanel value="5"><Teaching /></TabPanel>
                            <TabPanel value="6"><Astro /></TabPanel>
                            <TabPanel value="7"><Contact /></TabPanel>
                        </Box>
                    </TabContext>
                </Paper>
            </Container>
        </Box>
    );
}

export default App;

